var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"str4 str_wrap",staticStyle:{"height":"100px"}},[_c('a',{attrs:{"href":"#"}},_vm._l((_vm.logoMap),function(data){return _c('img',{staticClass:"img",attrs:{"src":data.src,"alt":""}})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }